// extracted by mini-css-extract-plugin
export default {"months":"Months_months__eSAiw","arrow":"Months_arrow__UEihG","display-value":"Months_display-value__Cr9ta"};